<template>
  <Layout>
    <div class="router-view">
      <div class="mx-auto max-w-md px-8 pb-6">
        <p class="font-bold mb-5">When do you want cover to start?</p>
        <DatePicker
          ref="datePicker"
          v-model="effectiveDate"
          :error="errors.effectiveDate"
          :disable-dates="disabledDates"
          class="mb-6"
          :inline="true"
          format="d MMMM yyyy"
          use-utc
          @selectDisabledDate="selectDisabledDate"
        />
        <DrButton
          :loading="loading"
          :class="{ 'btn-disabled': !isValidDate }"
          class="w-full btn-blue"
          data-cy="btn-select-start-date"
          @click.prevent="submit"
        >
          {{ canConvertWithoutBilling ? 'Confirm' : 'Set up payment' }}
        </DrButton>
      </div>
    </div>
  </Layout>
</template>

<script>
import { mapGetters } from 'vuex'
import Layout from '@/router/layouts/Main'
import DatePicker from '@/components/DatePicker.vue'
import axiosQuoteApi from '@/services/axiosQuoteApi'

export default {
  components: {
    Layout,
    DatePicker,
  },
  data () {
    return {
      loading: false,
      errors: {
        effectiveDate: false,
      },
      disabledDates: {
        to: new Date(new Date().setHours(23, 59, 59) - 86400000),
        from: new Date(Date.now() + 86400000 * 29),
      },
    }
  },
  computed: {
    ...mapGetters({
      premises: 'premises/all',
      getChargebeeEstimate: 'getChargebeeEstimate',
      isCouponWithFreeLegalEntered: 'isCouponWithFreeLegalEntered',
    }),
    effectiveDate: {
      get () {
        return this.$store.getters.getEffectiveDate
      },
      set (value) {
        this.$store.commit('updateEffectiveDate', value)
        if (this.isValidDate && this.errors.effectiveDate) {
          this.errors.effectiveDate = false
        }
      },
    },
    isValidDate () {
      if (this.effectiveDate) {
        const formattedDate = new Date(this.effectiveDate).setHours(23, 59, 59)
        const today = new Date().setHours(0, 0, 0)
        const daysLimit = new Date(Date.now() + 86400000 * 30).setHours(0, 0, 0)
        if (formattedDate >= today && formattedDate <= daysLimit) return true
      }
      return false
    },
    quoteTotalValue () {
      if (this.getChargebeeEstimate.total || this.getChargebeeEstimate.total === 0) {
        return this.getChargebeeEstimate.total / 100
      }
      return this.$store.getters.getTotal
    },
    canConvertWithoutBilling () {
      return this.isCouponWithFreeLegalEntered && this.quoteTotalValue === 0
    },
  },
  mounted () {
    this.$refs.datePicker.selectedDate = new Date(this.effectiveDate) < Date.now() ? Date.now() : this.effectiveDate
  },
  methods: {
    submit () {
      this.loading = true
      const date = new Date(this.effectiveDate)
      this.$store.commit('updateEffectiveDate', date.toISOString())

      const contactData = this.$store.state.contact
      if (this.$store.getters.getChargebeeEstimate.total) {
        contactData.quoteTotalValue = this.$store.getters.getChargebeeEstimate.total / 100
      } else {
        contactData.quoteTotalValue = this.$store.getters.getTotal
      }

      axiosQuoteApi
        .put(`quote/${this.$store.state.quoteId}/contact/extended`, contactData)
        .then((response) => {
          this.loading = true
        })
        .catch(() => {
          this.loading = false
          return this.$router.push('/404')
        })

      contactData.piRatingType = this.$store.getters.getPiRatingType
      contactData.quoteTotalValue = this.quoteTotalValue
      contactData.premises = this.premises

      this.$store.dispatch('checkSanctions').then((res) => {
        axiosQuoteApi
          .post(`quote/${this.$store.state.quoteId}/contact/account`, contactData)
          .then((response) => {
            this.reference = response.data.reference
            // If using 'underpinned' couponId, convert quote without billing details page. Else go to billing page
            if (this.canConvertWithoutBilling) {
              axiosQuoteApi
                .post(`quote/${this.$store.state.quoteId}/convert_no_payment`, {
                  couponId: this.$store.getters.getCouponId,
                })
                .then((QuoteResponse) => {
                  this.convertedToAccountRef = QuoteResponse.data.accountReference
                  this.loading = false
                  this.$router.push('/success')
                })
                .catch(() => {
                  this.loading = false
                  this.$router.push('/404')
                })
            } else {
              this.loading = false
              this.$router.push('/checkout/payment')
            }
          })
          .catch(() => {
            this.loading = false
            this.$router.push('/404')
          })
      })
    },
    selectDisabledDate () {
      this.errors.effectiveDate = 'Start date must be within the next 30 days'
    },
  },
}
</script>
